const polygonContractAddress = "0x840856B642f8186f20B689298B94F16ad532b319";// nft

export default polygonContractAddress